import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { Address } from '.'

export class StreetType extends EnumEntity {
  @Type(() => Address)
  addresses: Address[];
}
